import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { updateQuestion } from "./api";
import { invalidateAllQueries } from "utils/utils";

function buildPayload(values) {
  if (!values || typeof values !== "object") return {};

  const { ...rest } = values;
  return {
    ...Object.fromEntries(
      Object.entries(rest).filter(
        ([_, v]) => v !== "" && v !== undefined && v !== null
      )
    ),
  };
}

export function useUpdateQuestion() {
  return useMutation({
    mutationFn: async ({ item, questionId }) => {
      const payload = buildPayload(item);
      const response = await updateQuestion({ item: payload, questionId });
      return response;
    },
    onSuccess: () => {
      toast.success("Question Updated Successfully");
      invalidateAllQueries();
    },
    onError: (error) => {
      toast.error(error.message);
      console.log(error.message);
    },
  });
}
